var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Run_1;
import './runOutput'; // force import for JsonSchema
import '@symon-ai/wisepipe-common'; // force import for JsonSchema
import { Utils, S3File } from '@symon-ai/wisepipe-common';
import { DateConverter, JSON, JsonConverter, JsonSchema, MapConverter } from '@symon-ai/wisepipe-serialize';
import { RunTrigger } from './runRequest';
export var RunStatus;
(function (RunStatus) {
    RunStatus["Running"] = "running";
    RunStatus["Failed"] = "failed";
    RunStatus["Cancelled"] = "cancelled";
    // Complete = 'complete' // Deprecated, replaced by Completed
    RunStatus["Completed"] = "completed";
})(RunStatus || (RunStatus = {}));
export var RunErrorCodes;
(function (RunErrorCodes) {
    RunErrorCodes["Unknown"] = "run.unknown";
    RunErrorCodes["OutOfMemory"] = "run.outOfMemory";
    RunErrorCodes["ImportFailed"] = "run.importFailed";
    RunErrorCodes["ExportFailed"] = "run.exportFailed";
    RunErrorCodes["CalculationFailed"] = "run.calculationFailed";
    RunErrorCodes["InvalidNode"] = "run.invalidNode";
    RunErrorCodes["MissingConfig"] = "run.missingConfig";
    RunErrorCodes["ActiveBuild"] = "run.activeBuild";
    RunErrorCodes["OutOfCredits"] = "run.outOfCredits";
    RunErrorCodes["ActiveRun"] = "run.activeRun";
    RunErrorCodes["DataSourceNotFound"] = "run.dataSourceNotFound";
})(RunErrorCodes || (RunErrorCodes = {}));
export var BasicWisepipeConnectionType;
(function (BasicWisepipeConnectionType) {
    BasicWisepipeConnectionType["CSV"] = "wise___wiseS3ConnectionType";
    BasicWisepipeConnectionType["EXCEL"] = "wise___wiseS3ConnectionType_EXCEL";
})(BasicWisepipeConnectionType || (BasicWisepipeConnectionType = {}));
const schema = {
    $id: 'urn:wisepipe-common-computation:Run',
    type: 'object',
    properties: {
        runID: { type: 'string', uid: 9 },
        pipeID: { type: 'string', uid: 10 },
        name: { type: 'string', minLength: 1 },
        dataMap: {
            type: 'object',
            additionalProperties: { type: 'string', uid: 9 }
        },
        exportMap: {
            type: 'object',
            additionalProperties: { type: ['string', 'null'], if: { type: 'string' }, then: { uid: 9 } }
        },
        status: { type: 'string', enum: Object.values(RunStatus) },
        progress: { type: 'number', minimum: 0, maximum: 1 },
        start: { type: 'string', format: 'date-time' },
        outputs: { type: 'array', items: { $ref: 'urn:wisepipe-common-computation:RunOutput' } },
        end: { type: 'string', format: 'date-time' },
        error: { type: 'object' },
        transientExportFileMap: {
            type: 'object',
            additionalProperties: { type: 'array', items: { $ref: 'urn:wisepipe-common:S3File' } }
        },
        runTrigger: { type: 'string', enum: Object.values(RunTrigger) },
        scheduleID: { type: 'string', uid: 9 },
        selectedOutputs: { type: 'array', items: { type: 'string', uid: 10 } },
        skippedDSRefreshes: { type: 'array', items: { type: 'string', uid: 9 } },
        nodeToIsExcelExport: {
            type: 'object',
            additionalProperties: { type: 'boolean' }
        }
    },
    required: ['runID', 'pipeID', 'name', 'dataMap', 'status', 'progress', 'start']
};
let Run = Run_1 = class Run {
    constructor(runID, pipeID, name, dataMap, status, progress, start, outputs, end, error, exportMap, transientExportFileMap, runTrigger, scheduleID, selectedOutputs, skippedDSRefreshes, nodeToIsExcelExport) {
        this.runID = runID;
        this.pipeID = pipeID;
        this.name = name;
        this.dataMap = dataMap;
        this.status = status;
        this.progress = progress;
        this.start = start;
        if (outputs)
            this.outputs = outputs;
        if (end)
            this.end = end;
        if (error !== undefined)
            this.error = error;
        if (exportMap !== undefined)
            this.exportMap = exportMap;
        if (transientExportFileMap !== undefined)
            this.transientExportFileMap = transientExportFileMap;
        if (runTrigger !== undefined)
            this.runTrigger = runTrigger;
        if (scheduleID !== undefined)
            this.scheduleID = scheduleID;
        if (selectedOutputs !== undefined)
            this.selectedOutputs = selectedOutputs;
        if (skippedDSRefreshes !== undefined)
            this.skippedDSRefreshes = skippedDSRefreshes;
        if (nodeToIsExcelExport !== undefined)
            this.nodeToIsExcelExport = nodeToIsExcelExport;
        JSON.validate(this, Run_1);
    }
    static newID() {
        return Utils.newID();
    }
    static bufferID(base64ID) {
        return Utils.base64StringToBuffer(base64ID);
    }
    static getTableName(orgID, runID, outputID, port) {
        return `${orgID}/${runID}/${outputID}/${port}`;
    }
};
__decorate([
    JsonConverter(new MapConverter())
], Run.prototype, "dataMap", void 0);
__decorate([
    JsonConverter(new MapConverter())
], Run.prototype, "exportMap", void 0);
__decorate([
    JsonConverter(new DateConverter('date-time'))
], Run.prototype, "start", void 0);
__decorate([
    JsonConverter(new DateConverter('date-time'))
], Run.prototype, "end", void 0);
__decorate([
    JsonConverter(new MapConverter(S3File))
], Run.prototype, "transientExportFileMap", void 0);
__decorate([
    JsonConverter(new MapConverter())
], Run.prototype, "nodeToIsExcelExport", void 0);
Run = Run_1 = __decorate([
    JsonSchema(schema)
], Run);
export { Run };
//# sourceMappingURL=run.js.map